export default __webpack_public_path__ + "static/media/NCEthiopia.cd0b82cc.png";